import React from "react"
import { useState, useEffect } from "react"
import { GetApi } from "../../api/api"
import { Accordion, Card, Col, OverlayTrigger, Popover, Row } from "@trimbleinc/modus-react-bootstrap"
import * as Icon from "react-bootstrap-icons"

interface AttributeType {
  id: number
  name?: string
  dataType?: string
}

const FeatureType = (props: { fcId: string; ftId: number; left: boolean; setFeatureTypeName: any }) => {
  const [attributeTypes, setAttributeTypes] = useState(new Array<AttributeType>())

  useEffect(() => {
    const getAnyFeatureType = async () => {
      GetApi().then((api) => {
        api.getAnyFeatureType(props.fcId, props.ftId, true, undefined).then(async (response) => {
          props.setFeatureTypeName(response.name)
          if (response.attributeTypes === undefined || response.attributeTypes === null) {
            setAttributeTypes([{ name: "No attributes", id: 0 }])
          } else {
            setAttributeTypes(
              response.attributeTypes.map((attribute) => ({
                name: attribute.name,
                id: attribute.attributeTypeId,
                dataType: attribute.dataType
              }))
            )
          }
        })
      })
    }
    getAnyFeatureType()
  }, [props.ftId])

  return (
    <>
      {attributeTypes.map((attribute) => (
        <AttributeType {...{ attribute }} key={attribute.id} />
      ))}
    </>
  )
}

const AttributeType = (props: { attribute: AttributeType }) => {
  const { attribute } = props

  const renderTooltip = (
    <Popover id="ActionPropoverItem" className="conversion-shadow">
      <Popover.Content className="small-custom">
        <div className="text-muted" key="attrib-popover-heading" style={{ minWidth: "160px" }}>
          <b>Attribute properties</b>
        </div>
        {
          [
            { label: "Name", value: attribute.name },
            { label: "ID", value: attribute.id },
            { label: "Data type", value: attribute.dataType },
          ].map(({ label, value }) => (
            <Row key={label}>
              <Col className="pr-0" style={{minWidth: "90px", maxWidth: "90px"}}>{label}</Col>
              <Col className="pl-0 text-truncate"><b>{value}</b></Col>
            </Row>
          ))
        }
      </Popover.Content>
    </Popover>
  )

  return (
    <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
    {/* <OverlayTrigger placement="right" trigger="click" overlay={renderTooltip}> */}
      <div key={attribute.id} className="cre-list-hover px-2 cursor-pointer text-truncate py-1 small-custom">
        <Icon.Hospital color="blue" size={12} />
        &nbsp;
        <span>{attribute.name}</span>
      </div>
    </OverlayTrigger>
  )
}

export const FeatureTypes = (props: { left: boolean; fcId: string; ftId: number }) => {
  const [featureTypeName, setFeatureTypeName] = useState("")

  const positionClasses = props.left ? "float-right ml-auto mt-5 mr-5" : "float-left mr-auto mt-5 ml-5"

  return (
    <Accordion defaultActiveKey="0" className={positionClasses}>
      <Card>
        <Accordion.Toggle
          className="border-0 px-2 py-1"
          eventKey="0"
          style={props.left ? { backgroundColor: "#464b52" } : { backgroundColor: "#0063a3" }}
        >
          <Card.Header className="cre-feature-type-card-header p-0">
            <div className="mb-0 pr-5 text-left" id="collapsible-group-item-1" style={{ color: "white" }}>
              <b>{featureTypeName} [{props.ftId === 0 ? "" : props.ftId}]</b>
            </div>
          </Card.Header>
        </Accordion.Toggle>

        <Accordion.Collapse eventKey="0">
          <Card.Body className="p-0 border rounded-bottom">
            <FeatureType
              fcId={props.fcId}
              ftId={props.ftId}
              left={props.left}
              setFeatureTypeName={setFeatureTypeName}
            />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  )
}
